<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-02 00:12:30
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-02 00:50:17
-->
<template>
  <div class="SupplyDetail">
    <search-header />

    <div class="supply-content">
      <div class="supply-content-left">
        <img :src="'/app/common/attachment?id=' + data.photo" />
      </div>

      <div class="supply-content-right">
        <div class="title">{{ data.name }}</div>
        <div class="sub-title">
          <span>发布时间：{{ data.createTime }}</span>
        </div>

        <div class="content-row">
          <div class="label">所属行业：</div>
          <div class="data">{{ data.industry }}</div>
        </div>
        <div class="content-row">
          <div class="label">项目展示期：</div>
          <div class="data">{{ data.expirationTime }}</div>
        </div>
        <div class="content-row">
          <div class="label">所在区域：</div>
          <div class="data">{{ data.areaCode }}</div>
          <div class="label">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：
          </div>
          <div class="data">{{ this.isxian ? data.phone : " 登录后获取" }}</div>
        </div>

        <!-- 购买 -->
        <a-button class="buy-btn" type="primary" @click="orderAdd(0)">{{
          "立即下单"
        }}</a-button>
      </div>
    </div>
    <div class="content-detail">
      <p class="title_top">
        <span class="line"></span>
        <span class="step_title">基本信息</span>
      </p>
      <!--  -->
      <div class="row">
        <div class="step_one_left">
          <ul class="info_ul_one">
            <li>所属行业：{{ data.industry }}</li>
          </ul>
        </div>
      </div>
      <!--  -->

      <p class="title_top">
        <span class="line"></span>
        <span class="step_title">描述：</span>
      </p>
      <div v-html="data.content" style="padding: 20px">
        <!-- <a-descriptions title="专利" layout="vertical" bordered>
          <a-descriptions-item label="Product"> Cloud Database </a-descriptions-item>
          <a-descriptions-item label="Billing Mode"> Prepaid </a-descriptions-item>
          <a-descriptions-item label="Automatic Renewal"> YES </a-descriptions-item>
        </a-descriptions> -->
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";

import request from "../util/request";
export default {
  
  name: "supplyDetail",
  data() {
    return {
      data: {},
      paraId: "",
    };
  },
  mounted() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
        this.isxian = true;
    }
    let id = this.$route.query.id;
    this.paraId = id;
    console.log(id);
    this.quertDetail(id);
  },
  methods: {
    orderAdd(pram) {
      if (pram == 0) {
        request({
          url: "/api/client/common/order",
          method: "post",
          data: qs.stringify({ id: this.paraId, type: "ZLJY" }),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }).then((res) => {
          if (res.code == "200") {
            this.$message.success("下单成功");
              this.$router.push({path:"/brandTrade?id=ZLJY"})
          } else {
            this.$message.warning(res.msg);
          }
        });
      } else {
        this.$message.warning("已经卖出");
      }
    },
    quertDetail(id) {
      request({
        url: "/api/client/common/product/" + id,
        method: "get",
      }).then((res) => {
        this.data = res.data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.supply-content {
  width: 1280px;
  background: #fff;
  margin: 20px auto;
  display: flex;
  .supply-content-left {
    width: 390px;
    img {
      margin: 20px;
      width: 350px;
      height: 350px;
      object-fit: contain;
    }
  }
  .supply-content-right {
    padding: 20px 0;
    flex: 1;
    .title {
      height: 60px;
      line-height: 30px;
      vertical-align: middle;
      font-size: 20px;
      color: #222;
    }
    .sub-title {
      text-align: left;
      vertical-align: middle;
      height: 40px;
      line-height: 40px;
      color: #888;
      font-size: 14px;
    }
    .content-row {
      display: flex;
      align-items: center;
      height: 40px;
      .label {
        color: #9b9b9b;
      }
      .data {
        color: #666;
      }
    }
    .buy-btn {
      margin: 40px;
      font-size: 16px;
    }
  }
}
.content-detail {
  width: 1280px;
  background: #fff;
  margin: 0 auto;
  .title_top {
    width: 100%;
    height: 34px;
    text-align: left;
    background: #e9f0f8;
    .line {
      height: 16px;
      line-height: 34px;
      display: inline-block;
      vertical-align: middle;
      margin-left: 15px;
      border-left: 4px solid #4790ff;
    }
    .step_title {
      font-size: 18px;
      color: #333;
      font-weight: 700;
      text-align: left;
      line-height: 34px;
      margin-left: 10px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .row {
    display: flex;
    ul > li {
      line-height: 40px;
      font-size: 15px;
      color: #666;
    }
    div {
      flex: 1;
    }
  }
}
ul {
  list-style: none;
}
</style>
